:host {
  --width: auto;
  --min-height: auto;
  --height: auto;

  --max-width: 560px;
  --z-index: 9999;
  --top: 200px;
  --max-height: calc(90% - var(--top));
  --padding: 16px;
  --radius: 4px;
  --font-size: 16px;
  --font-color: rgba(26, 26, 26, 1);
  --font-weight: 500;
  --icon-size: 18px;
  --line-height: 22px;
  --title-margin-bottm: 8px;

  --sub-font-size: 14px;
  --sub-font-color: rgba(26, 26, 26, 0.9);
  --sub-font-line-height: 1.4;

  --animate: translate(calc(100% + 1rem));

  /* info */
  --background: #e6f4ff;
  --border: solid 1px #91caff;
  --icon-fill: #1677ff;
  /* info */

  display: block;
  position: fixed;
  z-index: var(--z-index);

  top: var(--top);
  left: 50%;
  transform: translateX(-50%);
  max-height: var(--max-height);
  max-width: var(--max-width);
  width: var(--width);
  touch-action: none;
  user-select: none;
  overflow: hidden;
}

@media screen and (max-width: 1024px) {
  :host {
    --max-width: 85.3vw;
    --top: 20vh;
    --max-height: calc(90% - var(--top));
    --padding: 3.2vw;
    --font-size: 14px;
    --icon-size: 16px;
    --line-height: 18px;
    --title-margin-bottm: 4px;

    --sub-font-size: 12px;
  }
}

:host(.toast-inline) {
  position: relative;
}

:host(.toast-success) {
  --background: #f6ffed;
  --border: solid 1px #B7EB8F;
  --icon-fill: rgba(82, 196, 26, 1);
}

:host(.toast-warning) {
  --background: #fffbe6;
  --border: solid 1px #ffe58f;
  --icon-fill: #faad14;
}

:host(.toast-error) {
  --background: #fff2f0;
  --border: solid 1px #ffccc7;
  --icon-fill: #ff4d4f;
}


:host .toast-container {
  border-radius: var(--radius);
  padding: var(--padding);
  border: var(--border);
  background: var(--background);
  color: var(--font-color);
  display: flex;
  gap: 8px;

  transform: var(--animate);
  transition: transform .3s ease;
}

:host(.toast-open.toast-closeable) .toast-container {
  padding-right: calc(var(--padding) + 28px);
}

:host(.toast-open) .toast-container {
  transform: translate(0);
}

:host(.toast-has-subtitle) .toast-title {
  margin-bottom: var(--title-margin-bottm);
}

:host .toast-title {
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  padding: 0;
  margin: 0;
  line-height: var(--line-height);
}

:host .toast-subtitle {
  font-size: var(--sub-font-size);
  color: var(--sub-font-color);
  line-height: var(--sub-font-line-height);
  font-weight: normal;
  margin: 0;
  padding: 0;
}

.toast-content {
  flex: 1;
}

:host .toast--icon {
  width: var(--icon-size);
  height: var(--icon-size);
  padding: calc((var(--line-height) - var(--icon-size)) / 2);
}

:host .toast--icon path {
  fill: var(--icon-fill);
}

/* 关闭按钮 */
:host .close-container {
  padding-top: calc((var(--line-height) - var(--icon-size)) / 2);
  cursor: pointer;
}

:host .close-container svg path {
  fill: rgba(0, 0, 0, 0.45);
  transition: all .24s;
}

:host .close-container svg:hover path {
  fill: rgba(0, 0, 0, 0.88);
}

@media screen and (max-width: 1024px) {
  :host .close-container {
    padding-top: 0;
    margin-top: -2px;
  }

  :host .close-container svg {
    width: 14px;
    height: 14px;
  }
}

/* 关闭按钮 */


/* 卡片形式 */
:host(.toast-card) {
  --width: 560px;
  --min-height: auto;
  --height: auto;
  --max-width: 560px;

  --padding: 32px;
  --radius: 20px;
  --font-size: 24px;
  --icon-size: 70px;
  --line-height: 36px;
  --title-margin-bottm: 2px;

  --sub-font-size: 16px;

  --animate: translate(0, calc(-100% - 1rem));

  /* info */
  --background: rgba(255, 255, 255, 1);
  --border: solid 1px rgba(221, 221, 221, 1);
  --icon-fill: #1677ff;
  /* info */
}

:host(.toast-card.toast-success) {
  --icon-fill: rgba(82, 196, 26, 1);
}

:host(.toast-card.toast-warning) {
  --icon-fill: #faad14;
}

:host(.toast-card.toast-error) {
  --icon-fill: #ff4d4f;
}

:host(.toast-card) .toast-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
}

:host(.toast-card) .toast--icon {
  margin-bottom: 24px;
}

:host .close-container {
  position: absolute;
  top: 16px;
  right: 20px;
}

/* 卡片形式 */

@media screen and (max-width: 1024px) {

  /* 卡片形式 */
  :host(.toast-card) {
    --width: 85.3vw;
    --max-width: 85.3vw;

    --padding: 9.6vw;
    --radius: 10px;
    --font-size: 16px;
    --icon-size: 52px;
    --line-height: 24px;
    --sub-font-size: 13px;
  }

  :host(.toast-card) .toast--icon {
    margin-bottom: 12px;
  }
  /* 卡片形式 */
}
